import React, { Fragment } from 'react';
import styles from './BreadcrumbsNav.module.css';
import type { BreadcrumbItem } from '../types/BreadcrumbItem';
import BreadcrumbHomeIcon from './BreadcrumbHomeIcon';

type BreadcrumbsNavProps = {
  readonly items: readonly BreadcrumbItem[];
  readonly separator?: string;
  readonly prefix?: string;
  readonly showIcon?: boolean;
  readonly homeHref?: string;
  readonly className?: string;
};

function BreadcrumbsNav({
  items,
  separator = '/',
  prefix = '/',
  showIcon = true,
  homeHref = '/courses',
  className,
}: BreadcrumbsNavProps): React.ReactElement {
  const trimmedItems: readonly BreadcrumbItem[] = items.filter((item: BreadcrumbItem) => item.label.trim().length > 0);
  const handleHomeClick = (): void => {
    window.location.href = homeHref;
  };
  return (
    <nav aria-label="Breadcrumb" className={[styles.breadcrumbs, className].filter(Boolean).join(' ')}>
      {showIcon ? (
        <button
          type="button"
          onClick={handleHomeClick}
          className={styles.iconButton}
          aria-label="Go to home"
        >
          <BreadcrumbHomeIcon />
        </button>
      ) : null}
      <ol className={styles.list}>
        <li className={styles.item}>
          <span className={styles.prefix}>{prefix}</span>
        </li>
        {trimmedItems.map((item: BreadcrumbItem, index: number) => {
          const isLast: boolean = index === trimmedItems.length - 1;
          const isCurrent: boolean = item.isCurrent === true || isLast;
          const shouldRenderLink: boolean = !isCurrent && typeof item.href === 'string' && item.href.length > 0;
          const shouldRenderButton: boolean = !isCurrent && typeof item.onClick === 'function' && !shouldRenderLink;
          return (
            <Fragment key={`${item.label}-${index}`}>
              {index > 0 ? (
                <li className={styles.item} aria-hidden="true">
                  <span className={styles.separator}>{separator}</span>
                </li>
              ) : null}
              <li className={styles.item}>
                {shouldRenderLink ? (
                  <a className={[styles.text, isCurrent ? styles.textStatic : ''].filter(Boolean).join(' ')} href={item.href} aria-current={isCurrent ? 'page' : undefined}>
                    {item.label}
                  </a>
                ) : shouldRenderButton ? (
                  <button className={[styles.text, isCurrent ? styles.textStatic : ''].filter(Boolean).join(' ')} type="button" onClick={item.onClick} aria-current={isCurrent ? 'page' : undefined}>
                    {item.label}
                  </button>
                ) : (
                  <span className={[styles.text, styles.textStatic].filter(Boolean).join(' ')} aria-current={isCurrent ? 'page' : undefined}>
                    {item.label}
                  </span>
                )}
              </li>
            </Fragment>
          );
        })}
      </ol>
    </nav>
  );
}

export default BreadcrumbsNav;


